import React from 'react';
import { motion } from 'framer-motion';
import { QrCode, Receipt, UserCircle, Calendar, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function MemberCard() {
  const fadeIn = {
    initial: {
      opacity: 0,
      y: 20
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true
    },
    transition: {
      duration: 0.6
    }
  };
  const quickLinks = [{
    title: 'View Bill History',
    icon: <Receipt size={20} className="text-club-gold" data-id="element-1028" />,
    to: '/members/dashboard'
  }, {
    title: 'Update Contact Info',
    icon: <UserCircle size={20} className="text-club-gold" data-id="element-1029" />,
    to: '/members/information'
  }, {
    title: 'Book Facilities',
    icon: <Calendar size={20} className="text-club-gold" data-id="element-1030" />,
    to: '/facilities'
  }];
  return <div className="min-h-screen bg-club-canvas py-12 px-4 sm:px-6 lg:px-8" data-id="element-1031">
      <div className="max-w-md mx-auto space-y-8" data-id="element-1032">
        {/* Header */}
        <motion.div {...fadeIn} className="text-center" data-id="element-1033">
          <span className="eyebrow block mb-2" data-id="element-1034">Member Profile</span>
          <h1 className="text-4xl font-serif text-club-green" data-id="element-1035">Digital Card</h1>
        </motion.div>

        {/* Digital Membership Card */}
        <motion.div className="bg-club-green text-white p-8 rounded-sm relative overflow-hidden shadow-md" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-1036">
          {/* Decorative pattern */}
          <div className="absolute top-0 right-0 opacity-5 pointer-events-none transform translate-x-1/4 -translate-y-1/4" data-id="element-1037">
            <svg width="240" height="240" viewBox="0 0 100 100" data-id="element-1038">
              <circle cx="50" cy="50" r="40" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-1039" />
              <circle cx="50" cy="50" r="30" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-1040" />
              <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-1041" />
            </svg>
          </div>

          <div className="relative z-10 flex flex-col items-center text-center space-y-6" data-id="element-1042">
            {/* Profile Info */}
            <div className="space-y-3" data-id="element-1043">
              <div className="w-24 h-24 mx-auto rounded-full border-2 border-club-gold overflow-hidden bg-club-canvasAlt" data-id="element-1044">
                <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80" alt="Member Profile" className="w-full h-full object-cover" data-id="element-1045" />
              </div>
              <div data-id="element-1046">
                <h2 className="text-2xl font-serif tracking-wide" data-id="element-1047">
                  Arjun Reddy
                </h2>
                <p className="text-club-gold text-sm uppercase tracking-widest font-medium mt-1" data-id="element-1048">
                  Gold Life Member
                </p>
              </div>
            </div>

            {/* Divider */}
            <div className="w-full h-px bg-club-border/20" data-id="element-1049"></div>

            {/* QR Code Section */}
            <div className="bg-white p-4 rounded-sm shadow-inner" data-id="element-1050">
              <QrCode size={120} className="text-club-ink" strokeWidth={1.5} data-id="element-1051" />
            </div>

            <div data-id="element-1052">
              <p className="text-club-canvas/60 text-xs uppercase tracking-wider mb-1" data-id="element-1053">
                Member ID
              </p>
              <p className="font-mono text-lg tracking-widest" data-id="element-1054">CH-1420</p>
            </div>
          </div>
        </motion.div>

        {/* Quick Links */}
        <motion.div className="space-y-3" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-1055">
          <h3 className="text-lg font-serif text-club-green mb-4 px-1" data-id="element-1056">
            Quick Actions
          </h3>

          {quickLinks.map((link, index) => <Link key={index} to={link.to} className="flex items-center justify-between p-4 bg-white border border-club-border rounded-sm hover:border-club-gold hover:shadow-sm transition-all group" data-id="element-1057">
              <div className="flex items-center gap-4" data-id="element-1058">
                <div className="p-2 bg-club-canvasAlt rounded-full" data-id="element-1059">
                  {link.icon}
                </div>
                <span className="font-medium text-club-ink group-hover:text-club-green transition-colors" data-id="element-1060">
                  {link.title}
                </span>
              </div>
              <ChevronRight size={18} className="text-club-ink/40 group-hover:text-club-gold transition-colors" data-id="element-1061" />
            </Link>)}
        </motion.div>
      </div>
    </div>;
}